import {
    Dmenu
} from './dmenu.js'; //ドロワーメニュー
import {
    Env
} from './env.js'; //ブラウザなど環境チェック
// import {
//     ScrChecker
// } from './scroll-checker-simple.js';
// import {
//     PageAncher
// } from './page-ancher.js'; //ページ内アンカーリンク（スムーズスクロール）
// import {
//     LazyLoad
// } from './lazyload.js';
import {
    Opening
} from './opening.js';
import {
    ResizeElem
} from './resize.js';
// import smoothscroll from 'smoothscroll-polyfill';
// https://www.npmjs.com/package/smoothscroll-polyfill
// http://iamdustan.com/smoothscroll/

// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Main {
    constructor() {
        this.timerResized = false; //resize時
        this.timerScrolled = false; //scroll時
        this._click = '';
        this.env = {};
        this.loadedFlg = false;
        //this.scrChecker = {};
        //this.pageAncher = {};
        this.openingManager = {};
        this.resize = {};


        //debug
        this.isScrolling = 0;
        this.timeoutId;
    }



    updateDebug() {
        if (document.getElementById('debug')) {
            const debugLog = document.getElementById('debug');
            debugLog.querySelectorAll('p')[0].textContent = 'isScrolling = ' + this.isScrolling;
            //debugLog.querySelectorAll('p')[1].textContent = 'vimeo time = ' + this.openingManager.currentPos;
        }
    }
    updateDebug2() {
        if (document.getElementById('debug')) {
            const debugLog = document.getElementById('debug');
            debugLog.querySelectorAll('p')[1].textContent = 'vimeo time = ' + this.openingManager.currentPos;
            debugLog.querySelectorAll('p')[2].textContent = '動画ループ時点を超過 = ' + this.openingManager.overMovLoopEnd;


            const h1 = document.querySelectorAll('.index-bg')[0].clientHeight;
            const h2 = document.querySelectorAll('.mainvisual-container')[0].clientHeight;
            const h3 = document.querySelectorAll('.mainvisual-vimeo iframe')[0].clientHeight;

            const w1 = document.querySelectorAll('.index-bg')[0].clientWidth;
            const w2 = document.querySelectorAll('.mainvisual-container')[0].clientWidth;
            const w3 = document.querySelectorAll('.mainvisual-vimeo iframe')[0].clientWidth;

            debugLog.querySelectorAll('p')[3].textContent = 'index-bg: w=' + w1 + ',h=' + h1;
            debugLog.querySelectorAll('p')[4].textContent = 'mainvisual-container: w=' + w2 + ',h=' + h2;
            debugLog.querySelectorAll('p')[5].textContent = 'iframe: w=' + w3 + ',h=' + +h3;
        }
    }


    init() {
        //console.log('init');
        //this.scrCheck = new ScrPos();
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        // DOMContentLoaded時
        // ------------------------------
        window.addEventListener('DOMContentLoaded', () => {

            // ブラウザOS環境
            this.env = new Env();
            this.env.detectEnv();

            // スクロールチェッカー
            // this.scrChecker = new ScrChecker();
            // this.scrChecker.init();

            //page ancher - OP/ajax要素などある場合はOP後に
            // smoothscroll.polyfill();
            // this.pageAncher = new PageAncher();
            // this.pageAncher.init();

            // Resize
            this.resize = new ResizeElem();
            this.resize.resizing();

            // dmenu
            let dmenu = new Dmenu();
            dmenu.init();

            // Openingチェッカー
            this.openingManager = new Opening();
            this.openingManager.init();


        });



        // load時
        // ------------------------------
        window.addEventListener("load", () => {

            // Opening処理
            //this.openingManager.showMainContent(); //OP以下のコンテンツ templateタグ

            this.loadedFlg = true;


            window.setTimeout(() => {
                this.body.classList.add('loaded');
                this.openingManager.scrChecker_onUpdate();
            }, 400);

            // // スクロールチェッカー
            // this.scrChecker = new ScrChecker();
            // this.scrChecker.init();

            // スクロール時
            window.addEventListener('scroll', () => {
                this.openingManager.scrChecker_onUpdate();
                this.resize.resizing();

                //debug
                this.isScrolling = 1;
                clearTimeout(this.timeoutId);
                this.updateDebug();
                //this.openingManager.pauseLoop();
                this.timeoutId = setTimeout(() => {
                    this.isScrolling = 0;
                    this.updateDebug();
                    //this.openingManager.restartLoop();
                }, 500);
            });

            if (document.getElementById('debug')) {
                setInterval(this.updateDebug2.bind(this), 200);
            }



            // ウインドウリサイズ時
            window.addEventListener('resize', () => {
                this.openingManager.scrChecker_onUpdate();
                this.openingManager.onResize('prepare');

                if (this.timerResized !== false) {
                    clearTimeout(this.timerResized);
                }

                this.timerResized = setTimeout(() => {
                    //console.log('resize');
                    this.resize.resizing();
                    this.openingManager.onResize();
                    //this.sizeint.sizeInt();
                }, 700);
            });

            window.addEventListener("pageshow", () => {
                //タブが表示/アクティブ
                this.openingManager.onActive();
            });
            window.addEventListener("pagehide", () => {
                //タブが非表示になった iOSではwindow操作に関係すると発火しない?
                this.openingManager.onDeActive();
            });

        });
    }
}